import AppointmentBooking from './AppointmentBooking';
import { bookAppointment, getDealerAvailableTimeSlots } from '../../services/appointment';
import { useEffect, useState } from 'react';

function AppointmentBookingContainer({
  offerId,
  dealerId,
  onCancel = () => { },
  initialDate = new Date(),
  onSuccess = () => { },
}) {

  const [selectedDate, setSelectedDate] = useState(initialDate);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [isLoadingAvailableSlots, setIsLoadingAvailableSlots] = useState(false);
  const [errorAvailableSlots, setErrorAvailableSlots] = useState(null);

  useEffect(() => {
    const fetchAvailableSlots = async () => {
      setIsLoadingAvailableSlots(true);
      setErrorAvailableSlots(null); // Clear any previous errors
      try {
        const availableSlots = await getDealerAvailableTimeSlots({
          id: dealerId,
          date: selectedDate,
        })
        if (availableSlots?.status === 'success') {
          setAvailableSlots(availableSlots?.data?.slots || []);
        } else {
          setErrorAvailableSlots(availableSlots?.message || 'Failed to fetch available slots');
        }
      } catch (error) {
        setErrorAvailableSlots(error?.message || 'Failed to fetch available slots');
      } finally {
        setIsLoadingAvailableSlots(false);
      }
    }

    fetchAvailableSlots();
  }, [selectedDate, dealerId]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const result = await bookAppointment({
        offerId,
        ...data
      })
      console.log(result);
      if (result?.status === 'success') {
        onSuccess(data);
      } else {
        setErrorAvailableSlots(result?.message || 'Failed to book appointment');
      }
    } catch (error) {
      console.log(error);
      setErrorAvailableSlots(error || 'Failed to book appointment');
    } finally {
      setIsSubmitting(false);
    }
  }

  const clearError = () => {
    setErrorAvailableSlots(null);
  }

  return (
    <AppointmentBooking
      availableSlots={availableSlots}
      availableSlotsLoading={isLoadingAvailableSlots}
      availableSlotsError={errorAvailableSlots}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      onClearError={clearError}
    />
  )
}

export default AppointmentBookingContainer;